import { create } from 'zustand';

type ActiveFieldState = {
  activeField: string;
  setActiveField: (fieldName: string) => void;
  resetActiveField: () => void;
};

export const useActiveFieldStore = create<ActiveFieldState>()((set) => ({
  activeField: null,
  setActiveField: (fieldName: string) =>
    set(() => ({ activeField: fieldName })),
  resetActiveField: () => set(() => ({ activeField: null })),
}));
